import { useOutletContext } from 'react-router-dom';
import AnnualTamPrimes from '../organisms/AnnualTamPrimes';
import type { PrimesOutletContext } from './PrimesMonthlyPage';

const PrimesAnnualPage = () => {
  const outletContext = useOutletContext<PrimesOutletContext>();

  return (
    <AnnualTamPrimes
      key={`${outletContext?.tamEmail ?? 'admin'}-${outletContext?.referenceDate?.toISOString() ?? 'current'}`}
      tamEmail={outletContext?.tamEmail}
      referenceDate={outletContext?.referenceDate}
    />
  );
};

export default PrimesAnnualPage;
